import {post} from '@/utils/request';
import {erpserver,oaserver,erpplatserver} from '@/utils/baseUrl';
//判断联系单
export async function isCommitOpenPrice(params) {
    return post(erpserver+'/priceRecord/isCommitOpenPrice', params, true);
}
//揭牌save
export async function saveOpenPrice(params) {
    return post(erpserver+'/priceRecord/saveOpenPrice', params, true);
}
//揭牌提交
export async function updateOpenPriceState(params) {
    return post(erpserver+'/priceRecord/updateOpenPriceState', params, true);
}
//揭牌list
export async function list(params) {
    return post(erpserver+'/priceRecord/queryOpenPrice', params, true);
}
//查询客户
export async function getkhlist(params) {
    return post(erpserver+'/priceRecord/queryKh', params, true);
}
// 获取公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}




